import { NumberPlateScansComponent } from './component/numberplate-scans.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberPlateScanComponent } from './component/numberplate-scan.component';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';


@NgModule({
  declarations: [
    NumberPlateScansComponent,
    NumberPlateScanComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,

    CommonTranslationModule
  ],
  exports: [
    NumberPlateScansComponent
  ]
})
export class NumberplateScansModule { }
